<template>
  <div class="footer_box">
    <div
      class="content_box h_100 d_flex align_items_center justify_content_between"
    >
      <div class="center_box">
        <p>联系电话:<a href="tel:4001603672">400-160-3672</a></p>
        <p>招商加盟:<a href="tel:18911724816">18911724816</a>（刘经理）</p>
        <p>
          公司邮箱:<a href="mailto:yikewei168@126.com">yikewei168@126.com</a>
        </p>
        <p>公司地址:北京市海淀区上地十街1号院</p>
      </div>
      <div class="right_box d_flex">
        <div class="d_flex flex_column align_items_center">
          <img src="@/assets/common/official_account.jpg" alt="" srcset="" />
          <p>微信公众号</p>
        </div>
        <div class="d_flex flex_column align_items_center">
          <img src="@/assets/common/mini_program.jpg" alt="" srcset="" />
          <p>微信小程序</p>
        </div>
      </div>
    </div>
    <div class="copyright text_center">
      <span>版权所有:北京易可为信息科技有限公司</span>
      <a href="http://beian.miit.gov.cn/" target="_blank"
        >京ICP备2021012550号</a
      >
      <span>京公网安备11010802034916号</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      data: []
    };
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.footer_box {
  height: 344px;
  background: #212121;
  display: flex;
  flex-direction: column;
}

.center_box {
  max-width: 520px;
  // text-align: center;
  > p,
  > a {
    color: #ccc;
    font-size: 20px;
    line-height: 34px;
    margin-bottom: 12px;
    letter-spacing: 0.5px;
  }
  a {
    color: #ccc;
    text-decoration: none;
  }
}

.right_box {
  > div {
    margin-right: 30px;
  }
  img {
    width: 126px;
    margin-bottom: 20px;
  }
  p {
    color: #fff;
  }
}

.copyright {
  color: #ccc;
  font-size: 12px;
  padding-bottom: 16px;
  a {
    color: #ccc;
    margin: 0 8px;
  }
}
</style>
